import { defineComponent as _defineComponent } from 'vue'
import { AGTestCase, AGTestSuite } from "ag-client-typescript";
import { ref } from "vue";

import { generate_uid } from "@/utils";

interface PropTypes {
  ag_test_suite: AGTestSuite;
  suite_is_selected: boolean;
  selected_test_case_pks: Set<number>;
  is_open_text: string;
  is_closed_text: string;
}
interface EmitTypes {
  ag_test_suite_selected: [ag_test_suite: AGTestSuite];
  ag_test_case_selected: [ag_test_case: AGTestCase];
}

export default /*#__PURE__*/_defineComponent({
  __name: 'rerun_select_suite',
  props: {
    ag_test_suite: null,
    suite_is_selected: { type: Boolean },
    selected_test_case_pks: null,
    is_open_text: null,
    is_closed_text: null
  },
  setup(__props: any, { emit }: { emit: ({
  ag_test_suite_selected: [ag_test_suite: AGTestSuite];
  ag_test_case_selected: [ag_test_case: AGTestCase];
}), expose: any, slots: any, attrs: any }) {





const component_uid = generate_uid();
const is_open = ref(false);

return { __sfc: true,emit, component_uid, is_open }
}

})